import type { CreateNotification201SourceSourceUser } from './createNotification201SourceSourceUser';

export type CreateNotification201Source = {
  sourceUser?: CreateNotification201SourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
